<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId" v-show="adminShow">
        <el-select v-model="queryParams.userId" filterable clearable :placeholder="$t('app.smsTemplate.form.agent')" @change="search">
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="type">
        <el-select v-model="queryParams.type" filterable clearable :placeholder="$t('app.smsTemplate.form.selectOperator')" @change="search">
          <el-option v-for="item in operationList" :key="item.operationId" :label="item.operationName" :value="item.operationId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="auditStatus">
        <el-select v-model="queryParams.auditStatus" filterable clearable :placeholder="$t('app.smsTemplate.form.selectTemplateStatus')" @change="search">
          <el-option v-for="item in auditStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
            <el-button type="primary"  icon="el-icon-plus" @click="addSmsTemplate" v-hasPermi="['sms:center:templateAdd']">{{ $t('app.common.add') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" :label="$t('app.common.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="actionId" :label="$t('app.smsTemplate.table.templateId')" align="center"></el-table-column>
      <el-table-column prop="userId" :label="$t('app.smsTemplate.table.agent')" align="center" min-width="140px" v-show="adminShow"></el-table-column>
      <el-table-column prop="content" :label="$t('app.smsTemplate.table.templateContent')" align="center" width="260px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="type" :label="$t('app.smsTemplate.table.operator')" align="center" min-width="60px">
        <template slot-scope="{row}" >
          <el-tag v-if="row.type == '1'">{{ $t('app.common.chinaTelecom') }}</el-tag>
          <el-tag v-else-if="row.type == '2'" type="success">{{ $t('app.common.chinaMobile') }}</el-tag>
          <el-tag v-else-if="row.type == '3'" type="success">{{ $t('app.common.chinaUnicom') }}</el-tag>
          <el-tag v-else type="warning">{{ $t('app.common.international') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="scene" :label="$t('app.smsTemplate.table.applicationScenario')" align="center"></el-table-column>
      <el-table-column prop="auditStatus" :label="$t('app.smsTemplate.table.templateStatus')" align="center" min-width="100">
        <template slot-scope="{row}" >
          <el-tag v-if="row.auditStatus == '0'" type="danger">{{ $t('app.smsTemplate.status.rejected') }}</el-tag>
          <el-tag v-else-if="row.auditStatus == '1'" type="warning">{{ $t('app.smsTemplate.status.auditing') }}</el-tag>
          <el-tag v-else-if="row.auditStatus == '2'" type="success">{{ $t('app.smsTemplate.status.approved') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="reason" :label="$t('app.smsTemplate.table.reason')" align="center"></el-table-column>
      <el-table-column :label="$t('app.common.operation')" width="300" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-edit"  @click="auditRow(scope.row.id)" v-hasPermi="['sms:center:templateAudit']" v-if="scope.row.auditStatus == '1'">{{ $t('app.common.audit') }}</el-button>
          <el-button size="mini" type="primary" plain icon="el-icon-edit"  @click="updateRow(scope.row.id)" v-hasPermi="['sms:center:templateEdit']" v-if="scope.row.auditStatus == '0'">{{ $t('app.common.edit') }}</el-button>
          <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="deleteRow(scope.row.id)" v-hasPermi="['sms:center:templateDel']">{{ $t('app.common.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"/>

    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="740px" append-to-body v-dialogDrag :close-on-click-modal="false">
        <el-form :model="form" label-width="width:80%;" ref="form" :rules="rules">
          <el-form-item  prop="userId" v-show="adminShow">
            <el-select v-model="form.userId" filterable clearable :placeholder="$t('app.smsTemplate.form.selectAgent')" style="width:700px;" :disabled="isAuditDialog">
              <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="type">
            <el-select v-model="form.type" filterable clearable :placeholder="$t('app.smsTemplate.form.selectOperator')" style="width:700px;" :disabled="isAuditDialog">
              <el-option v-for="item in operationList" :key="item.operationId" :label="item.operationName" :value="item.operationId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('app.smsTemplate.dialog.contentLabel')" prop="content" >
            <el-input type="textarea"  v-model="form.content" :rows="5" style="width:700px;" :placeholder="$t('app.smsTemplate.dialog.contentPlaceholder')" @change="changeContent($event)" :disabled="isAuditDialog"></el-input>
          </el-form-item>
          <div style="font-size: 12px;margin-bottom: 20px;color:#999">{{ $t('app.smsTemplate.dialog.variableNote') }}</div>
          <el-button @click="insertVar()" type="primary" plain style="margin-bottom: 20px;" v-if="!isAuditDialog">{{ $t('app.smsTemplate.dialog.insertVariable') }}</el-button>
          <el-form-item :label="$t('app.smsTemplate.dialog.sceneLabel')" prop="scene" >
            <el-input type="textarea"  v-model="form.scene" :rows="5" style="width:700px;" :placeholder="$t('app.smsTemplate.dialog.scenePlaceholder')" :disabled="isAuditDialog"></el-input>
          </el-form-item>
          <div style="font-size: 12px;margin-bottom: 20px;color:#999">{{ $t('app.smsTemplate.dialog.sceneNote') }}</div>
          <el-form-item :label="$t('app.smsTemplate.dialog.reasonLabel')" prop="reason" v-if="isAuditDialog">
            <el-input type="textarea"  v-model="form.reason" :rows="2" style="width:700px;" :placeholder="$t('app.smsTemplate.dialog.reasonPlaceholder')" ></el-input>
          </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog()">{{ $t('app.smsTemplate.dialog.cancel') }}</el-button>
        <el-button type="success" @click="saveInfo()" v-if="!isAuditDialog">{{ $t('app.smsTemplate.dialog.submitAudit') }}</el-button>
        <el-button type="success" @click="auditInfo(0)" v-if="isAuditDialog">{{ $t('app.smsTemplate.dialog.reject') }}</el-button>
        <el-button type="success" @click="auditInfo(2)" v-if="isAuditDialog">{{ $t('app.smsTemplate.dialog.approve') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  simSmsTemplateList,
  simSmsTemplateDelete,
  simSmsTemplateDetail,
  simSmsTemplateAdd,
  simSmsTemplateUpdate,
  simSmsTemplateAudit,
  agentList
} from "@/api/api.js";
export default {
  name: "smsTemplate",
  data(){
    return {
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
      typeList:[
        {
          value: 1,
          label: "中国移动平台"
        },
      ],
      agentList: [],
      operationList:[
        { operationId: '2', operationName: this.$t('app.common.chinaMobile') },
        { operationId: '4', operationName: this.$t('app.common.international')  }
      ],
      auditStatusList:[
        { value: '0', label: this.$t('app.smsTemplate.status.rejected') },
        { value: '1', label: this.$t('app.smsTemplate.status.auditing') },
        { value: '2', label: this.$t('app.smsTemplate.status.approved') },
      ],
      // 弹窗部分
      title:"",
      dialog:false,
      form:{
        type:"",
        userId:"",
        content:"",
        scene:""
      },
      varCount:1,
      rules:{
        type:[
          { required: true, message: this.$t('app.smsTemplate.validation.selectOperator'), trigger: "blur" }
        ],
        content:[
          { required: true, message: this.$t('app.smsTemplate.validation.enterContent'), trigger: "blur" }
        ],
        scene:[
          { required: true, message: this.$t('app.smsTemplate.validation.enterScene'), trigger: "blur" }
        ],

      },
      isAuditDialog: false,
    }
  },
  computed: {
    adminShow () {
        return this.$store.getters.user.userType =='1'
    },
    dialogTitle() {
      if (this.isAuditDialog) {
        return this.$t('app.smsTemplate.dialog.auditTitle');  //审核短信模版
      } else if (this.form.id) {  // 编辑时 form 存在 id
        return this.$t('app.smsTemplate.dialog.editTitle');  // 编辑短信模版
      } else {
        return this.$t('app.smsTemplate.dialog.addTitle');  // 新增短信模版
      }
    }
  },
  methods:{
    // 获取列表信息
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      simSmsTemplateList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search(){
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery(){
      this.resetForm("queryForm");
      this.search()
    },
    // 新增
    addSmsTemplate(){
      this.title = this.$t('app.smsTemplate.dialog.addTitle');  // 新增短信模版
      this.isAuditDialog = false;
      this.dialog = true;
      this.form = {};
    },
    // 编辑
    updateRow(id){
      this.title = this.$t('app.smsTemplate.dialog.editTitle');  // 编辑短信模版
      this.isAuditDialog = false;
      this.dialog = true;
      let params = {
        id:id
      }
      simSmsTemplateDetail(params).then(res=>{
        this.form = res.data.data;
      })
    },
    // 审核
    auditRow(id){
      this.title = this.$t('app.smsTemplate.dialog.auditTitle');  // 审核短信模版
      this.isAuditDialog = true; 
      this.dialog = true;
      let params = {
        id:id
      }
      simSmsTemplateDetail(params).then(res=>{
        this.form = res.data.data;
      })
    },
    // 删除
    deleteRow(id){
      let params = {
        id: id,
      };
      this.$confirm(this.$t('app.smsTemplate.message.deleteConfirm'), this.$t('app.common.systemPrompt'), {
        confirmButtonText: this.$t('app.common.confirm'),
        cancelButtonText: this.$t('app.common.cancel'),
        type: "warning"
      }).then(() => {
        simSmsTemplateDelete(params).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: this.$t('app.smsTemplate.message.deleteSuccess') 
            });
            this.initData();
          }else{
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message:  this.$t('app.smsTemplate.message.deleteCancel')
        });
      });
    },
    // 弹窗的取消
    cancelDialog(){
      this.dialog = false;
    },
    // 插入变量
    insertVar(){
      if(this.form.content === undefined){
        this.$set(this.form, "content", "{" +this.varCount+ "}");
      } else {
        let arr = this.form.content.split("{");
        this.varCount = (arr.length - 1) > 0?arr.length:1;
        this.$set(this.form, "content", this.form.content + "{" +this.varCount+ "}");
      }
      this.varCount += 1;
    },
    // 清空内容
    changeContent(value){
      if(value === ""){
        this.varCount = 1;
      }
    },
    // 弹窗的保存
    saveInfo(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.id) {
            let params ={
              ...this.form
            }
            simSmsTemplateAdd(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: this.$t('app.common.success'),
                  message: this.$t('app.smsTemplate.message.addSuccess'),
                  type: "success",
                  duration: 1500
                });
                this.dialog = false;
                this.initData();
              }else{
                this.$message.error(res.data.message);
              }
            })
          }else{
            let params ={
              ...this.form
            }
            simSmsTemplateUpdate(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: this.$t('app.common.success'),
                  message: this.$t('app.smsTemplate.message.editSuccess'),
                  type: 'success'
                });
                this.dialog = false;
                this.initData();
              }
            })
          }
        }
      })
    },
    // 弹窗的审核
    auditInfo(value){
      this.form.auditStatus = value;
      let params ={
        ...this.form
      }
      simSmsTemplateAudit(params).then(res=>{
        if(res.data.code == 200){
          this.$notify({
            title: this.$t('app.common.success'),
            message: this.$t('app.smsTemplate.message.auditSuccess'),
            type: 'success'
          });
          this.dialog = false;
          this.initData();
        }
      })
    },
    // 弹窗的x
    dialogClose(){
      this.$refs.form.clearValidate();
      this.dialog = false;
    },
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        this.agentList = res.data.data;
      });
    },
  },
  created(){
    if(this.adminShow){
      this.queryAgentList();
    }
    this.initData();
  },
  mounted(){

  }
}
</script>